import React from 'react';
import './Pagination.css';

interface Props {
  page: number;
  totalPages: number;
  total: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
  compact?: boolean;
}

const PAGE_SIZES = [24, 48, 96, 200];

export default function Pagination({
  page, totalPages, total, limit, onPageChange, onLimitChange, compact
}: Props) {
  const from = page * limit + 1;
  const to   = Math.min((page + 1) * limit, total);

  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 0; i < totalPages; i++) pages.push(i);
  } else {
    pages.push(0);
    if (page > 2) pages.push('...');
    for (let i = Math.max(1, page - 1); i <= Math.min(totalPages - 2, page + 1); i++) {
      pages.push(i);
    }
    if (page < totalPages - 3) pages.push('...');
    pages.push(totalPages - 1);
  }

  return (
    <div className={`pagination ${compact ? 'pagination-compact' : ''}`}>
      {/* Showing X–Y of TOTAL */}
      <div className="pagination-info">
        {from.toLocaleString()}–{to.toLocaleString()} of{' '}
        <strong>{total.toLocaleString()}</strong>
      </div>

      {/* Prev / page numbers / Next */}
      <div className="pagination-controls">
        <button className="page-btn" disabled={page === 0} onClick={() => onPageChange(page - 1)}>‹</button>
        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`dots-${i}`} className="page-dots">…</span>
          ) : (
            <button
              key={p}
              className={`page-btn page-num ${p === page ? 'active' : ''}`}
              onClick={() => onPageChange(p as number)}
            >
              {(p as number) + 1}
            </button>
          )
        )}
        <button className="page-btn" disabled={page >= totalPages - 1} onClick={() => onPageChange(page + 1)}>›</button>
      </div>

      {/* Per page dropdown */}
      <div className="page-size-selector">
        <span className="page-size-label">Per page</span>
        <select
          className="page-size-select"
          value={limit}
          onChange={e => onLimitChange(Number(e.target.value))}
        >
          {PAGE_SIZES.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
